import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ThemeProvider } from 'styled-components'

import { BaseApp, theme, Toast, ToastContext } from '@reveni-io/reveni-ui'

import AppContext from './context/AppContext'
import initValue from './context/initValue'
import useIframeCopies from './hooks/useIframeCopies/useIframeCopies'
import useIframeTheme from './hooks/useIframeTheme/useIframeTheme'
import useToastInfo from './hooks/useToastInfo/useToastInfo'
import Router from './Router/Router'
import { buildMergedContext, getLocalStorage, getTheme, saveLocalStorage } from './helpers'

function App() {
  const [context, setContext] = useState(getLocalStorage('context') || initValue)
  const { i18n } = useTranslation()
  const { toastInfo, setToastInfo } = useToastInfo()
  const { iframeTheme } = useIframeTheme()
  const { iframeCopies } = useIframeCopies()

  useEffect(() => {
    try {
      const language = localStorage.language
      if (language) i18n.changeLanguage(language)
      // eslint-disable-next-line no-empty
    } catch {} //without catch because is to handle errors if the user is in iframe and incognito mode active.
  }, [i18n])

  useEffect(() => {
    saveLocalStorage('context', context)
  }, [context])

  const mergedContext = buildMergedContext(context, { iframeTheme, iframeCopies })

  const storeTheme = mergedContext?.merchantInfo?.theme

  return (
    <BaseApp>
      <ThemeProvider theme={getTheme(theme, storeTheme)}>
        <AppContext.Provider value={{ context: mergedContext, setContext }}>
          <ToastContext.Provider value={{ toastInfo, setToastInfo }}>
            <Router />
            <Toast show={toastInfo.show} type={toastInfo.type} message={toastInfo.message} />
          </ToastContext.Provider>
        </AppContext.Provider>
      </ThemeProvider>
    </BaseApp>
  )
}

export default App
